// extracted by mini-css-extract-plugin
export var label = "eTJblrWx";
export var altLabel = "Vkd21Ovu";